import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SportSharedComponent } from './sport.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';
import { FaIconSharedModule } from './../../atoms/fa.icon/fa.icon.module';

@NgModule({
    declarations: [
        SportSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        FaIconSharedModule
    ],
    exports: [
        SportSharedComponent
    ]
})

export class SportSharedModule {}
